import React, {useState, useEffect , useRef} from "react";
import Header from 'layouts/Header'
import Footer from 'layouts/Footer'
import Logo from 'layouts/logo';
import ScrollPageTop from 'components/ui/ScrollPageTop'
import {EyeOff, Eye, Loading} from "components/custom-icons";
import Button from 'components/ui/Button.tsx'
import Input from 'components/ui/input.jsx'

import { Formik, Field, Form } from 'formik';
import * as Yup from 'yup';
import {
   Control,
   FieldErrors,
   useForm,
   useFormState,
   useWatch,
   Controller
 } from 'react-hook-form';

import axios from 'axios';  
import { yupResolver } from '@hookform/resolvers/yup';
import {API_ENDPOINT,toast_anim , toast_anim_error} from 'components/config/Common'
import {useAuth} from 'contexts/provider/AuthProvider'
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import {Links} from 'routes/PathLink'
import ModalView from '_utils/ModalView'
import {deviceDetect} from "react-device-detect"
import { produce } from 'immer';
import SocialLogin from "components/auth/SocialLogin";
import OtpInput from "react-otp-input";
import PasswordInput from 'components/ui/password-input.tsx'

const SignupSchema = Yup.object().shape({
	  name: Yup.string()
          .required('You must need to provide your  name.')
          .min(2, 'Name is too short!')
          .max(50, 'Name is too long!'),
        email: Yup.string()
          .required('You must need to provide your email address.')
          .email('Invalid email.'),
        password: Yup.string().required('Password is required'),
});

const defaultValues = {  
   email: '',
   name:'',
   password:'',
 };

const PatientRegisterMain = (props) => {
   const [show, setshow] = useState(false);
   const [loading, setLoading] = useState(false);

   const { login } = useAuth();
   let navigate = useNavigate();
   const [isOpen, setIsOpen] = useState(false)
   const [otp, setotp] = useState('');
  const [final, setfinal] = useState('');
  const [whereto, setWhereto] = useState('');
  const [email, setEmail] = useState(false);
  const [userData,setUserData] = useState([]);
      const { register, handleSubmit , control, reset, setValue, setError, formState: { errors },} = useForm({
      defaultValues: defaultValues,
      resolver: yupResolver(SignupSchema),
      shouldFocusError:false,
   });
const refphone = useRef(null);
   useEffect(() => {
      //console.log("devicedata deviceDetect", deviceDetect())
      //console.log("devicedata browserName", mobileModel)
      if(localStorage.getItem('access_token')){
         return navigate("/", { replace: true });
      }
   })
   
   const handleView = () => {
		setIsOpen(true)
	}

     
   const closeModal = () => {
      setIsOpen(false)      
   }

    const dealerSubscription = async (values) => {
       //props.setActivestepfun(2);
       setLoading(true);
       let fromdata = {
              'email': values?.email,
              'name':values?.name,
              'password':values?.password,
             } 
     
             console.log('fromdata====',fromdata)
           
            axios
           .post(API_ENDPOINT+'/user_register', fromdata)
           .then((response) => {
              console.log("RESPONSE",response.data);
              if(response.data?.status == 1){
                  localStorage.setItem('access_token',response.data.access_token);
                  localStorage.setItem('user_type',response.data.user_type);
                  localStorage.setItem('user_id',response.data.user_id);
                  localStorage.setItem('user_name',response.data.user);
                   login({access_token:response.data.access_token, user_name:response.data.user_name})
                  navigate(Links.MYDASHBOARD, { replace: true });
              }
              //navigate(Links.REGISTRATIONSUCCESS, { replace: true });
              
             //setPost(response.data);
           });
      return false;
   }

   const setOtp = (val) =>{
      console.log("OPTBSADASD ",val)
      setotp(val);
   }
   return( <div className="flex justify-center">
            <div className="flex h-full min-h-screen w-screen flex-col justify-center bg-light py-6 px-5 sm:p-8 md:h-auto md:min-h-0 md:max-w-[480px] md:rounded-xl my-5">
                  <>
                  <div className="flex justify-center">
                  <h1 className="text-xl font-black text-accent">Register</h1>
                  </div>       
                  <form onSubmit={handleSubmit(dealerSubscription)}>  
                  <p className="mt-1 mb-8 text-center text-sm text-body sm:mt-5 sm:mb-10 md:text-base">
                     Register with your Email
                  </p>
                     <Input                
                        label={`Full name`}
                        {...register('name')}
                        variant="outline"
                        className="mb-5"
                        error={errors.name?.message}
                        required
                     /> 
                     <div className="mb-5">
                           <Input                
                              label={`Email`}
                              {...register('email')}
                              variant="outline"
                              className="mb-5"
                              type="email"
                              error={errors.email?.message}
                              required
                           />
                     </div>     
                      <div className="mb-2 w-full flex flex-col">
                        <PasswordInput                
                           label={`Password`}
                           {...register('password')}
                           variant="outline"
                           className="mb-5"                        
                           type='password'
                           error={errors.password?.message}
                           required
                        />
                        </div>
                        <div className="mb-5 w-full flex flex-col">
                        <PasswordInput                
                           label={`Confirm Password`}
                           {...register('confirm_password')}
                           variant="outline"
                           className="mb-5"                        
                           type='password'
                           error={errors.confirm_password?.message}
                           required
                        />
                     </div>                  
                     <div className="mt-8 flex justify-center">
                        {
                        !loading
                        ?
                        <Button className="w-full" >Create Account</Button>
                        :
                        <Loading className="w-10 h-10 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-assent-600" />
                        }
                     </div>
               </form>
               <SocialLogin mode='Login' user_type='user' />
               </>
            </div>
         </div>)
}

export default PatientRegisterMain